import { Box, Typography } from '@mui/material';
import React, { useCallback, useEffect } from 'react';

import { StyledPagination } from '../../theme/CustomComponents';
import { useProjects } from '../Providers/ProjectsProvider';
import ProjectCard, { ProjectCardSkeleton } from './ProjectCard';

interface ProjectsGridProps {
  handleProjectClick: (id: string) => void;
}

const ProjectsGrid: React.FC<ProjectsGridProps> = ({ handleProjectClick }) => {
  const { projectFolders, isLoading, totalPages, page, setPage, setPageSize, setShouldFetch } =
    useProjects();

  const handlePageChange = useCallback(
    (_e: React.ChangeEvent<unknown>, value: number) => {
      setPage(value - 1);
      setShouldFetch(true);
    },
    [setPage, setShouldFetch]
  );

  useEffect(() => {
    setPageSize(6);
    setShouldFetch(true);
  }, [setPageSize, setShouldFetch]);

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
      <Box display="flex" flexWrap="wrap" gap={2} justifyContent="center" width="100%">
        {isLoading ? (
          [...Array(6)].map((_, idx) => <ProjectCardSkeleton key={idx} />)
        ) : projectFolders.length > 0 ? (
          projectFolders.map((folder) => {
            return (
              <ProjectCard
                key={folder.project?.id}
                folder={folder}
                handleProjectClick={handleProjectClick}
              />
            );
          })
        ) : (
          <Typography>No projects found</Typography>
        )}
      </Box>
      {totalPages > 1 && projectFolders.length > 0 && (
        <StyledPagination
          count={totalPages}
          page={page + 1}
          onChange={handlePageChange}
          size="small"
          sx={{ justifyContent: 'center', display: 'flex', mt: 2 }}
          disabled={isLoading}
        />
      )}
    </Box>
  );
};

export default ProjectsGrid;
